import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from 'components/CncUI/Typography';

const useStyles = makeStyles(({ palette, breakpoints }) => ({
  root: {
    [breakpoints.down('xs')]: {
      textAlign: 'center',
    },
  },
  label: {
    color: palette.cncUI.primary.gray['+6'],
    margin: 0,
  },
  value: {
    margin: 0,
  },
}));

const Field = props => {
  const classes = useStyles();
  const { label, value } = props;

  return (
    <Grid container spacing={0} className={classes.root} alignItems="center">
      <Grid item md={3} sm={4} xs={12}>
        <Typography variant="caption" className={classes.label}>
          {label}
        </Typography>
      </Grid>
      <Grid item md={9} sm={8} xs={12}>
        <Typography variant="body2" className={classes.value}>
          {value}
        </Typography>
      </Grid>
    </Grid>
  );
};

export default Field;
